const usStates = require('@bluecrew/bluecrew-lib').usStates

class EditAddressController {
/* @ngInject */

    constructor(UsersService, $mdDialog, $mdToast, user) {
        this.UsersService = UsersService
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.user = { ...user }
        this.UsStates = usStates

        this.updatedAddress = {
            address: null,
            apartment: null,
            city: null,
            state: null,
            zipcode: null
        }
    }

    updateUserAddress () {
        if (this.userHasAddressInTheSystem() || (!this.userHasAddressInTheSystem() && this.user.status === 'ELIGIBLE')) {
            this.submitUserInfoForApproval()
        } else {
            this.updateUser()
        }
    }

    closeDialog () {
        this.$mdDialog.cancel()
    }

    updateUser () {
        this.user.address = this.updatedAddress.address
        this.user.apartment = this.updatedAddress.apartment
        this.user.city = this.updatedAddress.city
        this.user.state = this.updatedAddress.state
        this.user.zipcode = this.updatedAddress.zipcode

        this.UsersService.updateUser({
            userInfo: this.user
        })
            .then(() => {
                this.$mdDialog.hide(this.updatedAddress)
                this.$mdToast.show(
                    this.$mdToast.simple("Changes saved.")
                        .hideDelay(5000)
                )
            })
            .catch((err) => {
                this.$mdToast.showSimple('Failed to update profile info')
            })
    }

    submitUserInfoForApproval() {
        this.UsersService.submitUserContactInfoForApproval(this.updatedAddress)
            .then(() => {
                this.$mdDialog.hide()
                this.$mdToast.show(
                    this.$mdToast.simple("Changes submitted. We'll verify them and update your account as soon as possible.")
                        .hideDelay(5000))
            })
            .catch((err) => {
                this.$mdToast.showSimple('Failed to submit changes')
            })
    }

    userHasAddressInTheSystem = () => this.user.address ? true : false

}

export default EditAddressController
